import { readCookie } from '../../cookie';

/**
 * Checks whether the current logged-in user has admin / audit action privileges.
 * 
 * Rules:
 * 1. Explicit view-only overrides (viewonly / isViewOnly / hasauditaction: false) => View-Only (false)
 * 2. Explicit action overrides (hasauditaction: true / isAdmin: true / admin: true) => Admin (true)
 * 3. Super User (accountType includes 'super user' / 'superuser') => Admin (true)
 * 4. Admin in accountType / role / userType / userRoles => Admin (true)
 * 5. Field Admin (fieldAdmin: true / isFieldAdmin: true / field_admin role) => Admin (true)
 * 6. If accountType is NOT Super User, does NOT contain 'admin', and fieldAdmin is false => View-Only (false)
 */
export const checkIsAdmin = (customUserData = null) => {
  let userData = customUserData;
  if (!userData) {
    try {
      const raw = readCookie('userData');
      if (raw) {
        userData = typeof raw === 'string' ? JSON.parse(raw) : raw;
      }
    } catch (e) {
      console.warn('Unable to parse userData cookie:', e);
    }
  }

  if (!userData || typeof userData !== 'object') {
    return false;
  }

  // 1. Explicit view-only flags in user object
  if (
    userData.viewonly === true || userData.viewonly === 'true' ||
    userData.isViewOnly === true || userData.isViewOnly === 'true' ||
    userData.hasauditaction === false || userData.hasauditaction === 'false'
  ) {
    return false;
  }

  // 2. Explicit admin / action overrides
  if (
    userData.hasauditaction === true || userData.hasauditaction === 'true' ||
    userData.isAdmin === true || userData.isAdmin === 'true' ||
    userData.isadmin === true || userData.isadmin === 'true' ||
    userData.admin === true || userData.admin === 'true'
  ) {
    return true;
  }

  const accountType = String(userData.accountType || '').toLowerCase().trim();
  const role = String(userData.role?.name || userData.role || '').toLowerCase().trim();
  const userTypeName = String(userData.userType?.name || userData.userType || '').toLowerCase().trim();
  const userRoles = Array.isArray(userData.userRoles)
    ? userData.userRoles.map(r => String(r).toLowerCase().trim())
    : typeof userData.userRoles === 'string'
      ? [userData.userRoles.toLowerCase().trim()]
      : [];

  // 3. Super User check
  const isSuperUser =
    accountType.includes('super user') ||
    accountType.includes('superuser') ||
    accountType.includes('super_user') ||
    role.includes('super user') ||
    userRoles.includes('super user') ||
    userRoles.includes('superuser');

  if (isSuperUser) {
    return true;
  }

  // 4. Check if accountType, role, userType or userRoles contains 'admin'
  const containsAdmin =
    accountType.includes('admin') ||
    role.includes('admin') ||
    userTypeName.includes('admin') ||
    userRoles.some(r => r.includes('admin'));

  if (containsAdmin) {
    return true;
  }

  // 5. Field Admin check
  const isFieldAdmin =
    userData.fieldAdmin === true || userData.fieldAdmin === 'true' ||
    userData.isFieldAdmin === true || userData.isFieldAdmin === 'true' ||
    role.includes('field_admin') ||
    role.includes('fieldadmin') ||
    userRoles.some(r => r.includes('field_admin') || r.includes('fieldadmin'));

  if (isFieldAdmin) {
    return true;
  }

  // 6. Agar accountType super user nahi hai, admin contain nahi karta, aur field admin false hai => View-Only
  return false;
};

export const getLoggedInUser = () => {
  try {
    const raw = readCookie('userData');
    if (raw) {
      return typeof raw === 'string' ? JSON.parse(raw) : raw;
    }
  } catch (e) {
    console.warn('Unable to parse userData cookie:', e);
  }
  return null;
};
